import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const LINK_MODAL_ID = `${Decoration_Type.LINK}.modal`;
export {
  LINK_MODAL_ID
};
//# sourceMappingURL=constants.js.map
